import React from 'react';
import { cn } from '@/lib/utils';
import { CustomerEvent } from '../../types';
import { emailBodyParts } from '../emailThreads';
import { EmailHtmlBody } from './EmailHtmlBody';

/**
 * One email's body, in every viewer: the sanitised HTML when the message has no
 * plain body, otherwise `text` (the viewer's cut of the plain body).
 * `plainOnly` is for a collapsed preview, which is the HTML's text in one block.
 */
export function EmailBody({
  event,
  text,
  plainOnly,
  showEmpty,
  className,
}: {
  event: Pick<CustomerEvent, 'message' | 'body_html'>;
  text: string;
  plainOnly?: boolean;
  /** Say "(no text)" rather than render nothing. */
  showEmpty?: boolean;
  className?: string;
}) {
  const { html } = emailBodyParts(event);
  if (html && !plainOnly) return <EmailHtmlBody html={html} className={className} />;
  return (
    <div className={cn('whitespace-pre-wrap [overflow-wrap:anywhere]', className)}>
      {text || (showEmpty && <span className="italic text-muted-foreground">(no text)</span>)}
    </div>
  );
}
